import React from 'react'
import Link from 'shared/SlashLink';
import about1 from '../../images/about/buildlab_affordable_housing.jpg'

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="about_section section_space">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="about_image_1">
                            <img src={about1} alt="BUILDLAB - Affordable Housing" />
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="about_content">
                            <div className="heading_block">
                                <div className="heading_focus_text">
                                    Built for
                                    <span className="badge bg-secondary text-white">Affordable Housing</span>
                                </div>
                                <h2 className="heading_text">
                                    Technology that pays for itself on your next development
                                </h2>
                                <p className="heading_description mb-0">
                                    BUILDLAB embeds into every phase of affordable housing development — turning building technology from a budget line item into a measurable income generator. We design, coordinate, and deliver across the lifecycle so your team can focus on the units that matter.
                                </p>
                            </div>
                            <ul className="icon_list unordered_list_block mb-5">
                                <li>
                                    <span className="icon_list_icon">
                                        <i className="fa-solid fa-circle fa-fw" aria-hidden="true"></i>
                                    </span>
                                    <span className="icon_list_text">
                                        Secure ISP door fees, profit sharing, and complimentary community WiFi.
                                    </span>
                                </li>
                                <li>
                                    <span className="icon_list_icon">
                                        <i className="fa-solid fa-circle fa-fw" aria-hidden="true"></i>
                                    </span>
                                    <span className="icon_list_text">
                                        Design low-voltage, surveillance, door access, and life safety to spec — no overruns.
                                    </span>
                                </li>
                                <li>
                                    <span className="icon_list_icon">
                                        <i className="fa-solid fa-circle fa-fw" aria-hidden="true"></i>
                                    </span>
                                    <span className="icon_list_text">
                                        Coordinate every technology milestone from pre-construction through lease-up.
                                    </span>
                                </li>
                            </ul>
                            <ul className="btns_group unordered_list p-0 justify-content-start">
                                <li>
                                    <Link onClick={ClickHandler} to="/affordable-housing" className="btn">
                                        <span className="btn_label" data-text="See Your ROI">See Your ROI</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i>
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;